var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.mapStore.isHereVectorMap)?_c('MapNew',{ref:"mapNew"}):_c('Map',{ref:"map"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }